export const APP_DOMAIN_REGEX = /(app|local)(-[a-z]{0,2}\d)?\.hubspot(qa)?\.com/;